export const DEFAULT_BILLING_CURRENCY = 'USD';

const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
};

export function getCurrencySymbol(currency = DEFAULT_BILLING_CURRENCY) {
  return CURRENCY_SYMBOLS[currency] || currency;
}

// Same grouping/decimal separators for every UI language.
const AMOUNT_LOCALE = 'en-US';

// Backend sends DECIMAL strings like "49.0000": drop trailing zeros, keep cents only when present.
export function formatAmount(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return String(amount);

  const rounded = Math.round(value * 100) / 100;
  const fractionDigits = Number.isInteger(rounded) ? 0 : 2;
  return rounded.toLocaleString(AMOUNT_LOCALE, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatCurrencyAmount(amount, currency = DEFAULT_BILLING_CURRENCY) {
  if (amount === null || amount === undefined || amount === '') return '';
  return `${getCurrencySymbol(currency)}${formatAmount(amount)}`;
}

// Fixed two decimals for balances, invoices and usage.
export function formatBillingAmount(amount, currency = DEFAULT_BILLING_CURRENCY) {
  const value = Number(amount);
  return `${getCurrencySymbol(currency)}${Number.isFinite(value) ? value.toFixed(2) : '0.00'}`;
}
